export const CloseIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.55357 21.4998C1.28439 21.4998 1.01522 21.3989 0.80913 21.1928C0.396957 20.7806 0.396957 20.116 0.80913 19.7037L19.7018 0.809161C20.114 0.396946 20.7785 0.396946 21.1907 0.809161C21.6029 1.22138 21.6029 1.88597 21.1907 2.29818L2.298 21.1928C2.09192 21.3989 1.82274 21.4998 1.55357 21.4998Z"
        fill="#1A1A1A"
      />
      <path
        d="M1.55357 21.4998C1.28439 21.4998 1.01522 21.3989 0.80913 21.1928C0.396957 20.7806 0.396957 20.116 0.80913 19.7037L19.7018 0.809161C20.114 0.396946 20.7785 0.396946 21.1907 0.809161C21.6029 1.22138 21.6029 1.88597 21.1907 2.29818L2.298 21.1928C2.09192 21.3989 1.82274 21.4998 1.55357 21.4998Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M1.55357 21.4998C1.28439 21.4998 1.01522 21.3989 0.80913 21.1928C0.396957 20.7806 0.396957 20.116 0.80913 19.7037L19.7018 0.809161C20.114 0.396946 20.7785 0.396946 21.1907 0.809161C21.6029 1.22138 21.6029 1.88597 21.1907 2.29818L2.298 21.1928C2.09192 21.3989 1.82274 21.4998 1.55357 21.4998Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M1.55357 21.4998C1.28439 21.4998 1.01522 21.3989 0.80913 21.1928C0.396957 20.7806 0.396957 20.116 0.80913 19.7037L19.7018 0.809161C20.114 0.396946 20.7785 0.396946 21.1907 0.809161C21.6029 1.22138 21.6029 1.88597 21.1907 2.29818L2.298 21.1928C2.09192 21.3989 1.82274 21.4998 1.55357 21.4998Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M20.4464 21.5C20.1773 21.5 19.9081 21.399 19.702 21.1929L0.809305 2.29836C0.401338 1.88614 0.401338 1.22155 0.809305 0.809336C1.22148 0.401328 1.886 0.401328 2.29818 0.809336L21.1909 19.7039C21.603 20.1161 21.603 20.7807 21.1909 21.1929C20.9848 21.399 20.7156 21.5 20.4464 21.5Z"
        fill="#1A1A1A"
      />
      <path
        d="M20.4464 21.5C20.1773 21.5 19.9081 21.399 19.702 21.1929L0.809305 2.29836C0.401338 1.88614 0.401338 1.22155 0.809305 0.809336C1.22148 0.401328 1.886 0.401328 2.29818 0.809336L21.1909 19.7039C21.603 20.1161 21.603 20.7807 21.1909 21.1929C20.9848 21.399 20.7156 21.5 20.4464 21.5Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M20.4464 21.5C20.1773 21.5 19.9081 21.399 19.702 21.1929L0.809305 2.29836C0.401338 1.88614 0.401338 1.22155 0.809305 0.809336C1.22148 0.401328 1.886 0.401328 2.29818 0.809336L21.1909 19.7039C21.603 20.1161 21.603 20.7807 21.1909 21.1929C20.9848 21.399 20.7156 21.5 20.4464 21.5Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M20.4464 21.5C20.1773 21.5 19.9081 21.399 19.702 21.1929L0.809305 2.29836C0.401338 1.88614 0.401338 1.22155 0.809305 0.809336C1.22148 0.401328 1.886 0.401328 2.29818 0.809336L21.1909 19.7039C21.603 20.1161 21.603 20.7807 21.1909 21.1929C20.9848 21.399 20.7156 21.5 20.4464 21.5Z"
        fill="black"
        fill-opacity="0.2"
      />
    </svg>
  );
};
